<div class="wallboard-error-container">
    <div class="error-content">
        <div class="error-icon">
            <img src="../App_Themes/Standard/Images/CoreTheme/Errors/error.svg" alt="Error icon">
        </div>
        <div>
            <p class="error-message">{{ errorMessage }}</p>
        </div>
    </div>
</div>
